import React from 'react';
import DsModal from '../../DsModal';
import '../../../../css/common/chat/ChatMentionTaskResolutionModal.css';

const formatMentionDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const getMentionItemId = (item = {}) => String(item.mentionId || item.mention_id || '').trim();

export default function ChatMentionTaskResolutionModal({
  open = false,
  items = [],
  loading = false,
  resolvingMentionId = '',
  onResolveItem,
  onClose,
}) {
  const safeItems = Array.isArray(items) ? items.filter(Boolean) : [];

  return (
    <DsModal open={open} onClose={onClose} title="メンション確認" size="md">
      <div className="chat-mention-resolution-modal__body">
        {loading ? (
          <div className="chat-mention-resolution-modal__empty">読み込み中...</div>
        ) : safeItems.length > 0 ? (
          safeItems.map((item) => {
            const mentionId = getMentionItemId(item);
            const resolving = resolvingMentionId === mentionId;
            return (
              <article key={mentionId || `${item.messageId}:${item.createdAt}`} className="chat-mention-resolution-modal__item">
                <div className="chat-mention-resolution-modal__itemMain">
                  <div className="chat-mention-resolution-modal__meta">
                    <span>{formatMentionDate(item.createdAt || item.created_at)}</span>
                    <span>{item.senderName || item.sender_name || '送信者'}</span>
                  </div>
                  <p className="chat-mention-resolution-modal__preview">
                    {item.messagePreview || item.message_preview || '本文を表示できません。'}
                  </p>
                </div>
                <button
                  type="button"
                  className="chat-mention-resolution-modal__resolve"
                  disabled={Boolean(resolvingMentionId) || !mentionId}
                  onClick={() => {
                    if (typeof onResolveItem === 'function') onResolveItem(item);
                  }}
                  aria-label="このメンションを対応済みにする"
                >
                  {resolving ? '処理中' : '対応済み'}
                </button>
              </article>
            );
          })
        ) : (
          <div className="chat-mention-resolution-modal__empty">未対応メンションはありません。</div>
        )}
      </div>
    </DsModal>
  );
}
